
















import Vue from 'vue';
import BravadoTheme from '@/components/common/BravadoTheme/BravadoTheme.vue';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import { buildOAuthUrl } from '../utils';
import type { OAuthType, OAuthProvider } from '../types';

export default Vue.extend({
  name: 'SignUpSocialButtons',
  components: {
    BravadoButtonV3,
    BravadoTheme,
  },
  props: {
    // OAuthType
    type: {
      type: String,
      default: 'signUp',
    },
    // Additional login params
    loginParams: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    onClick(provider: OAuthProvider) {
      this.$emit(`login`, provider);

      // Ensure that emit fire before redirect
      this.$nextTick(() => {
        window.location.assign(buildOAuthUrl(provider, this.type as OAuthType, this.$route, this.loginParams));
      });
    },
  },
});
